const disputes = {
  'disputes.continue': 'Next',

  'disputes.categories.FRAUD': "I don't recognize this purchase",
  'disputes.categories.PROCESSING_ERROR':
    "There's something wrong with my purchase",
  'disputes.categories.DISAGREEMENT': 'The charged amount is wrong',

  'disputes.whatIssue': 'What is the issue?',
  'disputes.comment.placeholder': 'Describe what happened',

  'disputes.fraudDisclaimer1':
    'As safety measure, this card will be immediatly blocked.',
  'disputes.fraudDisclaimer2':
    'A new one will be send to the following address:',

  'disputes.submit.success':
    'Dispute in analysis. Following updates will be sent via e-mail.',
  'disputes.submit.failure': 'Something went wrong, please try again later.',

  'disputes.total_transactions': 'Total disputes transactions',
  'disputes.ANALYSING': 'Analysing',
  'disputes.APPROVED': 'Approved',
  'disputes.CANCELED': 'Canceled',
  'disputes.DENIED': 'Denied',
  'disputes.DRAFT': 'Draft',
  'disputes.OPEN': 'Open',
};

export default disputes;
